// eventFormHelpers.js — shared form defaults for EventFormModal

/** ExperienceStatus enum values (must match backend) */
export const EXPERIENCE_STATUSES = ["draft", "published", "cancelled", "ended"];

export const emptyItineraryItem = () => ({
  title: "",
  description: "",
  durationMinutes: 30,
  sortOrder: 0,
  imageId: null,
});

export const emptyForm = () => ({
  title: "",
  description: "",
  type: "TOUR",
  capacity: 10,
  durationMinutes: 60,
  price: 0,
  currency: "CAD",
  status: "published",
  // scheduling
  startAt:      "",
  endAt:        "",
  applyStartAt: "",
  applyEndAt:   "",
  season:       "",
  // SEO / meta
  banner:          "",
  featureIds:      [],
  metaTitle:       "",
  metaDescription: "",
  address: {
    street1: "",
    street2: "",
    city: "",
    state: "",
    region: "",
    zipcode: "",
    country: "Canada",
  },
  itineraryItems: [emptyItineraryItem()],
});
